// extracted by mini-css-extract-plugin
export default {"test":"DashboardTemplateCard_test__fkzUR","arrow":"DashboardTemplateCard_arrow__IY73d"};